import {useNavigate} from "react-router-dom";
import styled from "styled-components";
import {Alert} from "antd";
import {SilverButton} from "./LayoutWrapperCandidate.tsx";
import aiIcon from "../assets/ai_icon.png";
import {colors} from "../util/colors.ts";
import {useMediaQuery} from "@uidotdev/usehooks";

export const PromoAlert = () => {
    const navigate = useNavigate()
    const isMobile = useMediaQuery("only screen and (max-width : 768px)");

    return <StyledAlert
        message={
            <AlertContent>
                <AlertText>
                    silver+ gibt Ihnen Zugang zu 100.000+ Teilzeit-Jobs, Anschreiben-Generator, Jobcoach, Interviewtrainer und Steuer- und Rentenexperte. <br/>
                    <b>Jetzt für kurze Zeit 30% sparen und silver+ freischalten{!isMobile ? " um KI-Unterstützung zu erhalten." : "."}</b>
                </AlertText>
                <SilverButton type="primary" size="small" onClick={() => navigate('/silverplus')}>
                    Jetzt entdecken
                </SilverButton>
            </AlertContent>
        }
        showIcon={!isMobile}
        icon={<img src={aiIcon} style={{width: 20, height: 20}} alt=""/>}
    />
}

const StyledAlert = styled(Alert)`
  margin-bottom: 8px;
  border-radius: 12px;
    background: ${colors.neonPinkBg};
    border: none;

  .ant-alert-message {
    width: 100%;
  }

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

const AlertContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const AlertText = styled.span`
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.text};
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px
  }
`;
